import * as Sentry from "@sentry/react";

const dsn =
  process.env.REACT_APP_SENTRY_DSN ||
  "https://ea630cf8b8e8ce1e6a95ea6404dfd037@o4509715878182912.ingest.us.sentry.io/4509715954728960";
const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "development";
const release = process.env.REACT_APP_SENTRY_RELEASE || process.env.REACT_APP_RENDER_GIT_COMMIT;

const sampleRate = (value: string | undefined, fallback: number): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 && parsed <= 1 ? parsed : fallback;
};

const projectId = (() => {
  try {
    return new URL(dsn).pathname.replace("/", "") || null;
  } catch {
    return null;
  }
})();

export const frontendSentryRuntime = {
  dsnConfigured: Boolean(dsn),
  environment,
  release: release || null,
  projectId,
};

Sentry.init({
  dsn,
  environment,
  release,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: sampleRate(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE, 0.1),
  // Session Replay
  replaysSessionSampleRate: sampleRate(process.env.REACT_APP_SENTRY_REPLAY_SAMPLE_RATE, 0.05),
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: false,
  // Increase the number of breadcrumbs captured to provide more context for errors.
  maxBreadcrumbs: 200,
});
